import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { AuthReducerProps } from "../../store/reducers/authReducer";

import api from "../../api/api";

import Announcement from "./Announcement";
import { AnnouncementProps } from "./Announcements";

const LatestAnnouncement: React.FC<{}> = () => {
    const [data, setData] = useState<null | AnnouncementProps>(null);
    const uid: string | null = useSelector(
        (state: AuthReducerProps) => state.uid,
    );

    useEffect(() => {
        api.get("announcement/latest")
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                console.log("Failed to load the latest announcement");
                console.log("error", error);
                console.log("error.response", error.response);
            });
    }, [uid]);

    if (!data) {
        return null;
    }

    return <Announcement announcement={data} />;
};

export default LatestAnnouncement;
